import CityPageTemplate from "../city-template/CityPageTemplate";
import { rialtoConfig } from "./data";

export default function RialtoPage() {
  return <CityPageTemplate config={rialtoConfig} />;
}